export class LeadOnTrackStatusType {
    COLD = 'cold';
    WARM = 'warm';
    HOT  = 'hot';
}
